import { render } from "./DetectionManagement.vue?vue&type=template&id=118734eb&scoped=true"
import script from "./DetectionManagement.vue?vue&type=script&lang=js"
export * from "./DetectionManagement.vue?vue&type=script&lang=js"

import "./DetectionManagement.vue?vue&type=style&index=0&id=118734eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118734eb"]])

export default __exports__